// @flow
import { datadogRum } from '@datadog/browser-rum';
import { SplitFactory } from '@splitsoftware/splitio';
import type { SplitSDK, SplitFactoryConfig } from '@splitsoftware/splitio';

import { env } from 'config/env';
import { SPLITIO_API_KEY } from 'config';
import { importLocalSplits } from 'config/importLocalSplits';
import { isPlaywright } from 'utils/isPlaywright';

let features: SplitFactoryConfig['features'] | void = undefined;

export class SplitIOManager {
  static factory: SplitSDK;

  static createSplitFactory: (email: string) => void = (email) => {
    this.factory = SplitFactory({
      core: {
        authorizationKey: SPLITIO_API_KEY,
        key: email,
      },
      features,
      startup: {
        readyTimeout: 5, // 5 sec (value recommended by Split.io support)
      },
      impressionListener: {
        logImpression: (impressionData) => {
          datadogRum.addFeatureFlagEvaluation(
            impressionData.impression.feature,
            impressionData.impression.treatment
          );
        },
      },
    });
  };

  static getFactory(email: string): SplitSDK {
    if (this.factory == null) {
      this.createSplitFactory(email);
    }
    return this.factory;
  }
}

if (!isPlaywright() && env.DEPLOY_ENV === 'local') {
  // See local.split.yaml to change feature flags locally
  // or local.split.example.yaml if you haven't set this up yet
  features = importLocalSplits();
}

export const getFactory = (email: string): SplitSDK => {
  return SplitIOManager.getFactory(email);
};

/**
 * Split SDK singleton instance. Recommendation from split.io documentation
 * is to only have one instance of the SDK per application. This SDK can create
 * multiple clients, which are used to evaluate feature flags.
 */
